import { LogicContext } from '../types';
import config from '../../../config';
import { HOMEPAGE_BASE_PATH } from '../constants';

export const fetchPreviousPageInfo = async (
  context: LogicContext,
  event: unknown,
  params: { data?: { sidebar: boolean } }
) => {
  const basePath = config.base_path || HOMEPAGE_BASE_PATH;
  const previousPageArray = context.previousPageArray;
  let goBackNumber = 1;

  if (previousPageArray?.length) {
    if (params.data?.sidebar) {
      const numberOfRecentPagesInSidebar = findLastNotSidebarIndex(
        previousPageArray
      );
      goBackNumber += numberOfRecentPagesInSidebar;
    }

    const newPath =
      previousPageArray[previousPageArray.length - goBackNumber]?.pagePath ||
      basePath;

    return {
      path: newPath,
      previousPageArray: previousPageArray.slice(0, -goBackNumber),
      mainLayoutPath: newPath,
    };
  }

  return {
    path: basePath,
    mainLayoutPath: basePath,
  };
};

const findLastNotSidebarIndex = (
  previousPageArray: LogicContext['previousPageArray']
): number => {
  let numberOfPagesInSidebar = 0;
  const reversedPageArray = [...previousPageArray].slice().reverse();
  for (let page of reversedPageArray) {
    if (page.isInSidebar) {
      numberOfPagesInSidebar++;
    } else {
      return numberOfPagesInSidebar;
    }
  }

  return numberOfPagesInSidebar;
};
